var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationWithBlueBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#EFF6FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1722_27205)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1722_27205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H7V27H27V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1722_27205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9985 18.8089C15.2234 18.8089 13.7734 17.3672 13.7734 15.5839C13.7734 13.8005 15.2234 12.3672 16.9985 12.3672C18.7735 12.3672 20.2235 13.8089 20.2235 15.5922C20.2235 17.3756 18.7735 18.8089 16.9985 18.8089ZM16.9985 13.6172C15.9151 13.6172 15.0234 14.5005 15.0234 15.5922C15.0234 16.6839 15.9068 17.5672 16.9985 17.5672C18.0901 17.5672 18.9735 16.6839 18.9735 15.5922C18.9735 14.5005 18.0818 13.6172 16.9985 13.6172Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 25.968C15.768 25.968 14.5264 25.5013 13.5597 24.5763C11.1014 22.2096 8.3847 18.4346 9.4097 13.943C10.3347 9.86797 13.893 8.04297 17.0013 8.04297C17.0013 8.04297 17.0013 8.04297 17.0097 8.04297C20.118 8.04297 23.6763 9.86797 24.6013 13.9513C25.618 18.443 22.9013 22.2096 20.443 24.5763C19.4763 25.5013 18.2347 25.968 17.0013 25.968ZM17.0013 9.29297C14.5764 9.29297 11.4597 10.5846 10.6347 14.218C9.7347 18.143 12.2014 21.5263 14.4347 23.668C15.8763 25.0596 18.1347 25.0596 19.5763 23.668C21.8013 21.5263 24.268 18.143 23.3847 14.218C22.5513 10.5846 19.4263 9.29297 17.0013 9.29297Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1722_27205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWithBlueBack);
export default __webpack_public_path__ + "static/media/location_with_blue_back.e65a6d9af9d3ca8d59e3018032192dfc.svg";
export { ForwardRef as ReactComponent };